// Modules
import { eventChannel } from 'redux-saga'
import { call, delay, put, select, take, takeEvery } from 'redux-saga/effects'

// Store
import {
  wsFollowTransactionsChangeValue,
  wsFollowTransactionsMessageReceived,
} from 'store/actions/OrderBar/actions'
import {
  WS_CONNECT_FOLLOW_TRANSACTIONS,
  WS_DISCONNECT_FOLLOW_TRANSACTIONS,
} from 'store/actions/OrderBar/types'
import { URL_SOCKET_PATH, WS_TRANSACTIONS_PORT } from 'store/api'

// Constants
const TYPE_CLOSE = 'CLOSE'
const TYPE_ERROR = 'ERROR'
const TYPE_MESSAGE = 'MESSAGE'
const TYPE_OPEN = 'OPEN'

const THROTTLE_DELAY = 1000 // Throttle delay in milliseconds

// Handle incoming messages with custom throttle
function* handleMessages(action) {
  yield put(wsFollowTransactionsMessageReceived(action.payload))
  if (action?.type === TYPE_MESSAGE) {
    yield call(throttledHandleMessages, action)
  }
}

// Manual throttling (using delay) to avoid lodash dependency
function* throttledHandleMessages(action) {
  yield delay(THROTTLE_DELAY) // Apply throttle delay
  yield put(wsFollowTransactionsChangeValue()) // Dispatch after throttle
}

export function* watchFollowTransactionsWebSocket() {
  while (true) {
    yield take(WS_CONNECT_FOLLOW_TRANSACTIONS)

    // Select token from the state
    const token = yield select((state) => state.auth.token)

    // Call WebSocket connection with token
    const socket = yield call(connectWebSocket, { token })

    // Handle incoming messages from the WebSocket
    yield takeEvery(socket, handleMessages)

    // Wait for disconnection action
    yield take(WS_DISCONNECT_FOLLOW_TRANSACTIONS)
    socket.close()
  }
}

function connectWebSocket({ token }) {
  return eventChannel((emitter) => {
    if (!token) {
      return () => {} // Return no-op if token is missing
    }

    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const socket = new WebSocket(`${protocol}://${URL_SOCKET_PATH}:${WS_TRANSACTIONS_PORT}?token=${token}`)

    // WebSocket event handlers
    socket.onopen = () => emitter({ type: TYPE_OPEN })
    socket.onmessage = (event) => emitter({ type: TYPE_MESSAGE, payload: JSON.parse(event.data) })
    socket.onclose = () => emitter({ type: TYPE_CLOSE })
    socket.onerror = (error) => emitter({ type: TYPE_ERROR, payload: error })

    // Return unsubscribe function for socket cleanup
    return () => socket.close()
  })
}
